import React, { useState, useEffect } from "react";
//import PropTypes from "prop-types";
import PostForm from "./PostForm";
//import PostFeed from "./PostFeed";
import Spinner from "../common/Spinner";
import { getPosts } from "../../actions/postActions";
//import { Route } from "react-router-dom";
//import SearchBoxJobs from "../common/SearchBoxJobs";
import { useSelector, useDispatch } from "react-redux";
import TextFieldGroup from "../common/TextFieldGroup";
import { getCitiesPosts } from "../../actions/citiesPostActions";
import { getImages } from "../../actions/imageActions";
import { getExtraNowImages } from "../../actions/extraNowImageActions";
import  ExtraNowItem  from "../common/ExtraNowItem ";
import PropTypes from "prop-types";
import PostItem from "./PostItem";


const Posts = ({ match }) => {
  const post = useSelector((state)=>state.post)
  const citiespost =useSelector((state)=>state.citiespost)
  const extranowimages = useSelector((state)=>state.extranowimage.extranowimages)
  const loadingExtraNowImg= useSelector((state)=>state.extranowimage.loadingExtraNowImg)
  console.log('extranowimages', extranowimages)
  console.log('citiespost',citiespost)

  console.log('loadingExtraNowImg', loadingExtraNowImg)
const image =useSelector((state)=>state.image)
console.log('image',image)

  const [Search, setSearch] = useState({
    search: "",
  });
  const { search } = Search;
  // 
  const { posts, loading } = post;

  let filteredPosts =
    posts &&
    posts.filter((post) =>
      Object.values(post).join("").toLowerCase().includes(search.toLowerCase())
    );

  const updateSearch = (event) =>
    setSearch({ ...Search, search: event.target.value.substr(0, 30) });


  let postContent;

  if (posts === null || loading) {
    postContent = <Spinner />;
  } else {
    postContent = filteredPosts.map((post) => (
      <PostItem key={post._id} post={post} />
    ));
  }

  const dispatch = useDispatch();

  // useEffect(() => {
  //   dispatch(getPosts());
  // }, [dispatch]);

  // useEffect(() => {
  //   dispatch(getCitiesPosts());
  // }, [dispatch]);

  useEffect(() => {
    dispatch(getImages());
  }, [dispatch]);



  return (
    <div className="feed">
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <PostForm />
            {/* <div>
              <TextFieldGroup
                placeholder="Search"
                name="search"
                style={{ width: "50%" }}
                value={search}
                onChange={updateSearch}
                info="Filter by || Job title || Description ||Level || Location (city) || Country || Publisher || Remote type || Date"
              />
            </div> */}
            {/* <Route
              render={({ history }) => <SearchBoxJobs history={history} />}
            /> */}
           
            {/* {postContent} */}
          </div>
        </div>
      </div>
    </div>
  );
};

Posts.propTypes = {
  getPosts: PropTypes.func.isRequired,
  getExtraNowImages:PropTypes.func.isRequired,
  post: PropTypes.object.isRequired,
  extranowimages:PropTypes.object.isRequired
};

export default Posts;
